<template>
  <!-- 出库弹窗 -->
  <div>
    <BaseDialog title="出库" @handleShow="(val) => { visible = val }" :isshow="visible" width="700px" height="auto">
      <el-descriptions :column="3" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="药品名称">{{ drug.name }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ drug.medi_spec }}</el-descriptions-item>
        <el-descriptions-item label="类别">{{ drug.fee_type }}</el-descriptions-item>
        <el-descriptions-item label="生产厂家">{{ drug.company }}</el-descriptions-item>
      </el-descriptions>
      <div class="addform" style="margin-top:10px;">
        <el-form :model="ruleFormOut" ref="ruleFormOutRef" :rules="rulesFormOut" label-width="120px">
          <el-row>
            <el-col :span="16">
              <el-form-item label="批号">
                <el-input disabled v-model="ruleFormOut.batch_no" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="库存余量">
                <span>
                  {{ ruleFormOut.store_num }} {{ drug.min_package_unit_name }}
                  <template v-if="ruleFormOut.store_sub_num">{{ ruleFormOut.store_sub_num }} {{
                    ruleFormOut.drug.min_unit_name }}</template>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="出库数量">
                <el-col :span="6">
                  换算系数 {{ drug.min_package_num }}
                </el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormOut.out_num" placeholder="">
                    <template #append>{{ drug.min_package_unit_name }}</template>
                  </el-input>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormOut.out_sub_num" clearable placeholder="">
                    <template #append>{{ drug.min_unit_name }}</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="出库单位">
                <el-input disabled v-model="drug.dict_first_unit_name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="零售价">
                <el-input v-model="ruleFormOut.sell_price" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库总价">
                <template #default="scope">
                  <span v-if="drug.min_package_num">
                    <template v-if="drug.dict_first_unit == drug.min_package_unit&&ruleFormOut.out_num>=0">
                      {{ (ruleFormOut.sell_price * ruleFormOut.out_num + ruleFormOut.sell_price
                      *
                      ruleFormOut.out_sub_num / drug.min_package_num).toFixed(2) }}
                    </template>
                    <template v-else-if="drug.dict_first_unit == drug.min_unit&&ruleFormOut.out_num>=0">
                      {{ (ruleFormOut.sell_price * ruleFormOut.out_num * drug.min_package_num +
                      ruleFormOut.sell_price *
                      ruleFormOut.out_sub_num).toFixed(2) }}
                    </template>
                  </span>
                  <span v-else>0.00</span>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出库对象:">
                <el-select clearable placeholder="选择出库对象" v-model="ruleFormOut.out_touid">
                  <el-option v-for="item in userInfo" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库类型:" prop="dict_out_type">
                <el-select clearable placeholder="选择出库类型" v-model="ruleFormOut.dict_out_type">
                  <el-option v-for="item in dictList[205000000]" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出库时间：">
                <el-date-picker v-model="ruleFormOut.out_time" type="datetime" :clearable="false"
                  value-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择出库日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="ruleFormOut.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button @click="cancelOut">取消</el-button>
        <el-button type="primary" @click="handleOut()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { downLoadXlsx, gitDictList, TimestampToTime } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  export default {
    components: {
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1, ctx) {
      let proxy = getCurrentInstance()
      const state = reactive({
        visible: false,
        ruleFormOut: {},//首页退货
        drug: '',
        dictList: [],
        saveLoad:false,
        ruleFormOutRef: null,
        rulesFormOut: {
          dict_out_type: [{ required: true, trigger: 'change', message: '请选择' },],
        },
        userInfo: []
      })
      const initData = async (row) => {
        state.visible = true
        state.dictList = await gitDictList([
          '205000000',
        ])
        state.ruleFormOut = row
        console.log(row)
        state.ruleFormOut.sell_price = row.price
        state.ruleFormOut.out_sub_num = 0
        state.drug = row.drug
        state.ruleFormOut.out_time = timestampToTime()
        state.ruleFormOut.out_touid = JSON.parse(localStorage.getItem('ms_userData')).id
        getUserList()
      }
      const getUserList = async () => {
        let res = await service.post('/api/user/get_all_nurse')
        if (res.code === 0) {
          state.userInfo = res.data.list
        }
      }
      const timestampToTime = () => {
        let date = new Date()
        let year = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return year + M + D + h + m + s;
      }
      // 出库
      const handleOut = async () => {
        state.ruleFormOutRef.validate(async (valid) => {
          if (valid) {
            state.saveLoad = true
            state.visible = false
            let url = '/api/store_out_record/create_single_record'
            let data = {
              id: state.ruleFormOut.id == undefined ? '' : state.ruleFormOut.id,
              out_num: state.ruleFormOut.out_num == undefined ? 0 : state.ruleFormOut.out_num,
              out_sub_num: state.ruleFormOut.out_sub_num == undefined ? 0 : state.ruleFormOut.out_sub_num,
              out_touid: state.ruleFormOut.out_touid == null ? '' : state.ruleFormOut.out_touid,
              dict_out_type: state.ruleFormOut.dict_out_type == undefined ? '' : state.ruleFormOut.dict_out_type,
              out_time: state.ruleFormOut.out_time == undefined ? '' : state.ruleFormOut.out_time,
              sell_price: state.ruleFormOut.sell_price == undefined ? '' : state.ruleFormOut.sell_price,
              remark: state.ruleFormOut.remark == undefined ? '' : state.ruleFormOut.remark,
              min_package_num: state.ruleFormOut.min_package_num,
              min_package_unit: state.ruleFormOut.min_package_unit,
              min_package_unit_name: state.ruleFormOut.min_package_unit_name,
              min_unit_name: state.ruleFormOut.min_unit_name,
              min_unit: state.ruleFormOut.min_unit,
              dict_first_unit_name: state.ruleFormOut.dict_first_unit_name,
              dict_first_unit: state.ruleFormOut.dict_first_unit
            }
            await service.post(url, data)
            state.saveLoad = false
            ctx.emit('refreshDataList', state.ruleFormOut)
            
            state.ruleFormOut = {}
          } else {
            return false
          }
        })

      }

      // 弹窗取消
      const cancelOut = () => {
        state.visible = false
        state.ruleFormOut = ''
        state.drug = ''
      }
      return {
        ...toRefs(state),
        initData,
        handleOut,
        cancelOut,
        timestampToTime,
        getUserList
      }
    },
  }
</script>

<style scoped lang="scss">

</style>